import MuiBackdrop from '@mui/material/Backdrop';
import { styled } from '@mui/material/styles';

export const Backdrop = styled(MuiBackdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: theme.palette.background.default,
})) as typeof MuiBackdrop;
// ^ Typescript workaround. See https://github.com/mui-org/material-ui/issues/29161
